import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";

export const BLANK_TESTIMONIAL = { name: "", role_or_company: "", quote: "", brand: "", avatar_url: "", featured: false, approved: true };

/**
 * Owns all Testimonial CRUD state and API calls for the Admin
 * Testimonials page -- mirrors useAdminBlogPosts.js's pattern of
 * separating business logic from UI rendering.
 */
export const useAdminTestimonialItems = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => adminApi.get("/testimonials").then((res) => setItems(res.data)).finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const openNew = () => setEditing({ ...BLANK_TESTIMONIAL });
  const close = () => setEditing(null);

  const save = async (e) => {
    e.preventDefault();
    await adminApi.post("/testimonials", editing);
    close();
    load();
  };

  const toggleApproved = async (testimonial) => {
    await adminApi.put(`/testimonials/${testimonial.id}`, { ...testimonial, approved: !testimonial.approved });
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this testimonial?")) return;
    await adminApi.delete(`/testimonials/${id}`);
    load();
  };

  const updateEditingField = (field, value) => setEditing((prev) => ({ ...prev, [field]: value }));

  return { items, editing, loading, openNew, close, save, toggleApproved, remove, updateEditingField };
};
